import React, { useState, useEffect, useRef } from 'react';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import ITooltipButton from '@/components/interfaces/graphql/HtmlElement/TooltipButton';
import TooltipButtonSnippet from '@/components/common/HtmlElements/TooltipButton/Snippet';
import Axios from 'axios';
import * as Routes from '@/modules/routes';
import TooltipButton from '@/components/common/HtmlElements/TooltipButton/TooltipButton';
import { toCamelCase } from 'modules/TCIUtils';
import { GlossaryTerm, SlideObject } from '../../../types';

interface GlossaryCardProps {
  glossaryTerm: GlossaryTerm;
  slideObject: SlideObject;
}

const GlossaryCard = ({ glossaryTerm, slideObject }: GlossaryCardProps) => {
  const tooltipButtonRef = useRef(null);
  const locale = useSlideShowContext(state => state.locale);
  const isPresentMode = useSlideShowContext(state => state.isPresentMode);

  const term = locale === 'en' ? glossaryTerm.term_en : glossaryTerm.term_es;
  const example = locale === 'en' ? glossaryTerm.example_sentence_en : glossaryTerm.example_sentence_es;

  const [top, setTop] = useState(0);
  const [left, setLeft] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  // const [htmlElement, setHtmlElement] = useState(null);
  //
  // useEffect(() => {
  //   Axios.get(Routes.plato_api_get_html_elements_slide_objects_path(), { params: { id: slideObject.id } })
  //     .then((res) => {
  //       setHtmlElement(res.data.data[0]);
  //     });
  // }, []);

  useEffect(() => {
    if (!tooltipButtonRef) return;
    setTop(tooltipButtonRef.current.offsetTop + tooltipButtonRef.current.offsetHeight);
    setLeft(tooltipButtonRef.current.offsetLeft - (tooltipButtonRef.current.offsetWidth / 2));
  }, [tooltipButtonRef, imageLoaded]);

  const boldSubstring = (str, substring) => {
    if (!str) return;
    // Escape special regex characters in substring
    const escaped = substring.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escaped, 'g');
    return str.replace(regex, `<strong>${substring}</strong>`);
  };

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
      <img
        alt={glossaryTerm.term_en}
        className="tw-rounded-xl"
        src={glossaryTerm.s3_url}
        onLoad={() => setImageLoaded(true)}
      />
      <div className="tw-pt-4">
        <strong>{term}</strong>
      </div>
      <div className="tw-py-4" ref={tooltipButtonRef}>
        {isPresentMode ? (
          // htmlElement && <TooltipButton tooltipButton={toCamelCase(htmlElement)} />
          <TooltipButton tooltipButton={{
            data: {
              autoHide: true,
              buttonTextEn: 'Definition',
              buttonTextEs: 'Definición',
              tooltipStyles: {
                left,
                top,
              },
            },
            htmlEn: glossaryTerm.definition_en,
            htmlEs: glossaryTerm.definition_es,
            id: 1,
            modelId: slideObject.id,
            modelType: 'SlideObject',
            type: 'TooltipButton',
          } as ITooltipButton}
          />
        ) : (
          <TooltipButtonSnippet tooltipButton={{
            data: {
              buttonTextEn: 'Definition',
              buttonTextEs: 'Definición',
            },
            id: 1,
            type: 'TooltipButton',
          } as ITooltipButton}
          />
        )}
      </div>
      <hr className="tw-w-4/5" />
      {example && (
        <div>
          <strong>Example:</strong>
          <br />
          <span dangerouslySetInnerHTML={{ __html: boldSubstring(example, term) }} />
        </div>
      )}
    </div>
  );
};

export default GlossaryCard;
